<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :actions="false"
            :parentData="parentData"
            ref="masterComponent"
  >
  </g-master>
</template>
<script>
  export default {
    props: ['id_emp', 'fecha_ini'],
    data () {
      return {
        master: {
          endpoint: 'clock_mark',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_clock_mark'
            },
            actions: false,
            columns: [
              {title: 'Fecha y Hora Marcacion', dataIndex: 'date_clock_mark', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true},
              {title: 'Creado Por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado El', dataIndex: 'created_on', sorter: true}
            ]
          }
        }
      }
    },
    methods: {
      loadData () {
        this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.id_emp,
          fecha_ini: this.fecha_ini
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/OvertimeTurn/OvertimeLiqDetails.vue